// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M8 17a5 5 0 01-.916-9.916 5.002 5.002 0 019.832 0A5.002 5.002 0 0116 17m-7-5l3-3m0 0l3 3m-3-3v12\"/> </svg> ";
// Exports
module.exports = code;